import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root'
})
export class ClienteService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

 
  listarPorUsuarioAdmin(idUsuario) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Cliente/listarPorUsuarioAdmin?idUsuario=' + idUsuario)
        .subscribe(data => {
          resolve(data);
        }, error => {

        });
    });
  }
  obter(id) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Cliente/obter?id=' + id)
        .subscribe(data => {
          resolve(data);
        }, error => {

        });
    });
  }
  
  alterar(Cliente) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Cliente/Atualizar', Cliente)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
  alterarMembro(Cliente) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/MembroCliente/Atualizar', Cliente)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
  inserirMembro(membro) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/MembroCliente/Inserir', membro)
        .subscribe(data => {
          resolve(data);
        }, error => {
        });
    });
  }
  deletar(membro) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Cliente/deletar', membro)
        .subscribe(data => {
          resolve(data);
        }, error => {
        });
    });
  }
  deletarMembro(membro) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/MembroCliente/deletar', membro)
        .subscribe(data => {
          resolve(data);
        }, error => {
        });
    });
  }
  inserir(Cliente) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Cliente/Inserir', Cliente)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
  deletarCliente(Id) {
    return new Promise(async (resolve) => {
      this.http.delete('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Cliente/Deletar?id=' + Id)
        .subscribe(data => {
          resolve(data);
        }, error => {
        });
    });
  }
}
